module.exports = __webpack_public_path__ + "img/fg.logo.9fcf9d23.svg";